import { Component, OnInit,Input,Output,EventEmitter,ViewChild,ChangeDetectorRef} from '@angular/core';
import{SubjectManagmentService} from '../../../Services/subject-management/subject-management.service';
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup } from '@angular/forms';
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { VResourceAssign } from 'src/app/Validators/Validators';
import { SubjectResourceAssign } from 'src/app/Models/subject-resource-assignment';
//import { Console } from 'console';
import { AppOfflineStore } from '../../../app.offlineService';


@Component({
  selector: 'app-subject-resource-assignment',
  templateUrl: './subject-resource-assignment.component.html',
  styleUrls: ['./subject-resource-assignment.component.css']
})
export class SubjectResourceAssignmentComponent implements OnInit {
  @Input() ResourceAssignID:Number;
  @Input() subjectById:any;
  @Input() RedirectAssignedresourceId:Number;
  @Input() EditResourcePopup:boolean;
  @Input() ResourceAssigned:any;
  @Output() reset:EventEmitter<any> =new EventEmitter<any>();
  @Output() ResourceCancel1:EventEmitter<any> =new EventEmitter<any>();
  @Output() refresh:EventEmitter<any> =new EventEmitter<any>();
  @Output() DisableButton:EventEmitter<any> =new EventEmitter<any>();
  @Output() popup:EventEmitter<any> =new EventEmitter<any>();
  @Output() ResourcePopup:EventEmitter<any> =new EventEmitter<any>();
  @Output() closeAddEditElement:EventEmitter<any> =new EventEmitter<any>();


  SubjectRoleID:any;
  ResourceAssignform: FormGroup;
  ngSelectPU:any;
  EditResourceflag:boolean=false;
  InsertUpdateSubjectResource: SubjectResourceAssign;
  
  todayDate:Date = new Date();
  

  constructor(private cdr: ChangeDetectorRef,private appserv:AppOfflineStore,public pipe:DatePipe,public service:SubjectManagmentService,private toastr: ToastrService,private fb: FormBuilder) {
        this.todayDate=new Date(this.todayDate.setDate(this.todayDate.getDate() - 1));
        
        
   }
   InitializeForm(){
    this.ResourceAssignform = this.fb.group({
      PowerUserRoleTypeCode:["",VResourceAssign], 
      PowerUserId:["",VResourceAssign],
      StartDate:["",VResourceAssign], 
      EndDate:[], 
      RoleAssignmentStatusTypeCode:["",VResourceAssign], 
      AssignmentCommentText:[],
    });
  }




 
  ngOnInit() {

    this.InitializeForm();
   this.getCode();
   this.getAssignmentStatus();
   this.Descriptioncount();
   //this.cdr.detectChanges();

  
  
   if(this.RedirectAssignedresourceId>0)
  {
   this.ResourceAssignID=this.RedirectAssignedresourceId;

   this.getSubjectRoleAssignmentByID();
  } 
  else
  {
  this.getSubjectRoleAssignmentByID();
  }
  this.Editformvalidation();
  
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }



  dropDownIsDisabled(data:boolean):boolean{
    if (data=== true){return true;}else{return false;}}

    ResourceName1(data:any){
      this.getResourceName(data.target.value)
    }  

  ResponseSubjectRoleId:any;
  ngvalue:any;
  poweruser:any;
  getSubjectRoleAssignmentByID()
  {
    this.service.GetSubjectRoleAssignmentByID({'Subject_Role_Assignment_ID':Number(this.ResourceAssignID)}).subscribe((i:any)=>{
      this.ResponseSubjectRoleId=i;
      this.SubjectRoleID=this.ResponseSubjectRoleId.SubjectExistsInd;
      if(this.RedirectAssignedresourceId>0)
      {
        this.ResourceName = {
          LanguageTypeCode:this.appserv.MotherTongueLanguage,
          SubjectID:this.SubjectRoleID.Subject_Id,
          PowerUserRoleTypeCode:this.SubjectRoleID.Power_User_Role_Type_Code,
          PowerUserRoleStatusTypeCode:null,
          ExcludedPowerUserID:null,
          translatedInd:'N'
        }
        this.service.GetPowerUserByRole(this.ResourceName).subscribe((i:any)=>{
          this.getresourcedetails=i;
         // this.ngSelectPU=this.SubjectRoleID.Power_User_Id;
        this.ResourceAssignform.controls['PowerUserId'].setValue(this.SubjectRoleID.Power_User_Id);  
        this.ResourceAssignform.controls['PowerUserRoleTypeCode'].setValue(this.SubjectRoleID.Power_User_Role_Type_Code);
        this.ResourceAssignform.controls['StartDate'].setValue(this.SubjectRoleID.Start_Date);
        this.ResourceAssignform.controls['EndDate'].setValue(this.SubjectRoleID.End_Date);
        this.ResourceAssignform.controls['RoleAssignmentStatusTypeCode'].setValue(this.SubjectRoleID.Role_Assignment_Status_Type_Code);
        this.ResourceAssignform.controls['AssignmentCommentText'].setValue(this.SubjectRoleID.Assignment_Comment_Text);
        
        // this.poweruser=this.SubjectRoleID.Power_User_Id;
        //this.getResourceName(this.SubjectRoleID.Power_User_Role_Type_Code);
        //this.ResourceAssignform.controls['PowerUserId'].setValue(this.SubjectRoleID.Power_User_Id);
    // }).catch((e:any)=>{
    //   this.SubjectRoleID=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }
// }).catch((e:any)=>{
//   this.SubjectRoleID=null;
// });
}, (error:any) => { console.log(error) }
);
  }
  getcodes:any;
  getCode()
  {
    this.service.GetCode({'Tablename':"POWER_USER_ROLE_TYPE"}).subscribe((i:any)=>{
      this.getcodes=i;
    // }).catch((e:any)=>{
    //   this.getcodes=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  ResourceName:any
  getresourcedetails:any
  ngselect:any;
  selectrolecode:any
  getResourceName(index:any)
  {
    if(!this.EditResourcePopup){
    for (let item of this.getcodes) {
      if (item.Code==index) {
         this.selectrolecode=item;
      }
  }
    this.ResourceName = {
      LanguageTypeCode:this.appserv.MotherTongueLanguage,
      SubjectID:this.subjectById.Subject_Id,
      PowerUserRoleTypeCode:this.selectrolecode.Code,
      PowerUserRoleStatusTypeCode:null,
      ExcludedPowerUserID:null,
      translatedInd:'N'
      // LanguageTypeCode:"MAL",
      // SubjectID:1,
      // PowerUserRoleTypeCode:"SA",
      // PowerUserRoleStatusTypeCode:null,
      // ExcludedPowerUserID:null,
      // translatedInd:null
      
    }
    this.service.GetPowerUserByRole(this.ResourceName).subscribe((i:any)=>{
      this.getresourcedetails=i;
      this.ngSelectPU=this.getresourcedetails.Power_User_Id;
      if(this.EditResourcePopup){
        this.ResourceAssignform.controls['PowerUserId'].setValue(this.getresourcedetails.Full_Name);  
      }
    // }).catch((e:any)=>{
    //   this.SubjectRoleID=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }
}

  getAssignmentstatus:any;
  getAssignmentStatus()
  {
    this.service.GetCode({'Tablename':"ROLE_ASSIGNMENT_STATUS_TYPE"}).subscribe((i:any)=>{
      this.getAssignmentstatus=i;
    // }).catch((e:any)=>{
    //   this.getAssignmentstatus=null;
    // });
  }, (error:any) => { console.log(error) }
  );
  }

  error:any={isError:false,errorMessage:''};
 compareEndDates(){
  this.Editformvalidation();
   if(new Date(this.ResourceAssignform.controls['EndDate'].value)<new Date(this.ResourceAssignform.controls['StartDate'].value)){
      this.error={isError:true,errorMessage:'End Date cant before start date'};
   }
   else{
     this.error={isError:false,errorMessage:''};
   }

   if(!this.EditResourcePopup)
   {
     if(this.ResourceAssignform.controls['EndDate'].value==null){
      this.error={isError:false,errorMessage:''};
     }
   }
  
  if(this.ResourceAssignform.controls['EndDate'].value==this.SubjectRoleID.End_Date){
 
    this.error={isError:false,errorMessage:''};
  }
  //this.Editformvalidation();
 }
  error1:any={isError:false,errorMessage:''};
  compareStartDates(){
    this.Editformvalidation();
    if(new Date(this.ResourceAssignform.controls['StartDate'].value)<new Date(this.todayDate.setDate(this.todayDate.getDate()))){
       this.error1={isError:true,errorMessage:'Start Date cant before current date'};
    }
    else{
      this.error1={isError:false,errorMessage:''};
    }
    this.compareEndDates();
  if(this.ResourceAssignform.controls['StartDate'].value==this.SubjectRoleID.Start_Date){
    this.error1={isError:false,errorMessage:''};
  }
  this.Editformvalidation();
   }

  save_submitted:boolean=false;
  AssignResourceResponse:any;
  modalclose:boolean;
  Assignresourceclose:boolean;
  Save()
  {
   
    if(!this.error1.isError&&!this.error.isError){
      this.save_submitted=true;
    if (this.ResourceAssignform.valid) {
      if(!this.EditResourcePopup)
      {
        
        this.InsertUpdateSubjectResource = this.ResourceAssignform.value;
        this.InsertUpdateSubjectResource.SubjectId=this.subjectById.Subject_Id;
        this.InsertUpdateSubjectResource.StartDate=this.pipe.transform(this.InsertUpdateSubjectResource.StartDate,'MM/dd/yyyy');
        this.InsertUpdateSubjectResource.EndDate=this.pipe.transform(this.InsertUpdateSubjectResource.EndDate,'MM/dd/yyyy');
        //this.InsertUpdateSubjectResource.AssignmentCommentText=this.subjectById.;
      }
      else{
        this.InsertUpdateSubjectResource = this.ResourceAssignform.value;
        this.InsertUpdateSubjectResource.SubjectId=this.SubjectRoleID.Subject_Id;
        this.InsertUpdateSubjectResource.SubjectRoleAssignmentId=this.SubjectRoleID.Subject_Role_Assignment_ID;
        this.InsertUpdateSubjectResource.StartDate=this.pipe.transform(this.InsertUpdateSubjectResource.StartDate,'MM/dd/yyyy');
        this.InsertUpdateSubjectResource.EndDate=this.pipe.transform(this.InsertUpdateSubjectResource.EndDate,'MM/dd/yyyy');
      }
      
      this.service.CreateOrModifySubjectRoleAssignment(this.InsertUpdateSubjectResource).subscribe((i:any)=>{
        this.AssignResourceResponse=i;
        if(this.AssignResourceResponse.Message=="Success")
        {
          if(!this.EditResourcePopup)
          {
            this.toastr.success("Resource Assigned Successfully");
            this.ResourceCancel1.emit(this.Assignresourceclose);
            this.closeAddEditElement.emit(true);
            this.save_submitted=false;
          }
          else{
            this.toastr.success("Resource Assigned Successfully");
            this.reset.emit(this.modalclose);
            this.refresh.emit(this.modalclose)
            this.save_submitted=false;
          }

        }
        else
        {
        this.toastr.error(this.AssignResourceResponse.Message);
        this.save_submitted=false;
        this.popup.emit(this.modalclose);
        }
  //  })
  //  .catch((e:any)=>{
  //    this.AssignResourceResponse=e;
  //    if(!this.EditResourcePopup){
  //     this.ResourcePopup.emit(this.modalclose);
  //    }
  //    else{
  //     this.popup.emit(this.modalclose);
  //    }
  //    this.toastr.error(this.AssignResourceResponse.statusText);
  //    this.save_submitted=false;
     
  //  }
  //  ) 
}, (error:any) => { 
  this.AssignResourceResponse=error;
     if(!this.EditResourcePopup){
      this.ResourcePopup.emit(this.modalclose);
     }
     else{
      this.popup.emit(this.modalclose);
     }
     this.toastr.error(this.AssignResourceResponse.statusText);
     this.save_submitted=false;
  console.log(error) }
);
    }
  }
  

}


Descriptionvaluelength:any;
 DescriptionMaxlength:any;
 Descriptioncount(){
  this.DescriptionMaxlength=4000;
  if(this.ResourceAssignform.controls.AssignmentCommentText.value!=''&&this.ResourceAssignform.controls.AssignmentCommentText.value!=null){
    if(this.ResourceAssignform.controls.AssignmentCommentText.value.length>0){
        this.Descriptionvaluelength =this.ResourceAssignform.controls.AssignmentCommentText.value.length;
    }
    else{
      this.Descriptionvaluelength=0;
    }
  }
  else{
    this.Descriptionvaluelength=0;
    
  }
 }
 Refresh:any
 Editformvalidation()
 {
   this.Descriptioncount();
   var PowerUserRoleTypeCode = this.ResourceAssignform.controls['PowerUserRoleTypeCode'].value;
   var StartDate = this.ResourceAssignform.controls['StartDate'].value;
   var EndDate = this.ResourceAssignform.controls['EndDate'].value;
   var AssignmentCommentText = this.ResourceAssignform.controls['AssignmentCommentText'].value;
   var PowerUserId = this.ResourceAssignform.controls['PowerUserId'].value;
   var RoleAssignmentStatusTypeCode=this.ResourceAssignform.controls['RoleAssignmentStatusTypeCode'].value;
   if(this.EditResourcePopup){
    if(this.ResourceAssignform.valid){
   if(PowerUserRoleTypeCode!=this.SubjectRoleID.Power_User_Role_Type_Code)
   this.EditResourceflag=true;
   else if(StartDate!=this.SubjectRoleID.Start_Date)
   this.EditResourceflag=true;
   else if(EndDate!=this.SubjectRoleID.End_Date)
   this.EditResourceflag=true;
   else if(AssignmentCommentText!=this.SubjectRoleID.Assignment_Comment_Text)
   this.EditResourceflag=true;
   else if(PowerUserId!=this.SubjectRoleID.Power_User_Id)
   this.EditResourceflag=true;
   else if(RoleAssignmentStatusTypeCode!=this.SubjectRoleID.Role_Assignment_Status_Type_Code)
   this.EditResourceflag=true;
   else
   this.EditResourceflag=false;
   }
  }

   
   this.Refresh = {
    EditResourceflag:this.EditResourceflag,
    ResourceAssignform:this.ResourceAssignform,
          }

   this.DisableButton.emit(this.Refresh);
 }

 Addresource(data:any){
  this.Save();
 }


}
